



























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import { IProvisionRequest } from "@/models/provisioning";

@Component({
  computed: {
    ...mapState({
      payloadScope(state: IState, getters) {
        return getters[
          `data/${DataModules.PROVISIONING_REQUESTS}/payloadScope`
        ](this.requestId);
      },
      payload(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.PROVISIONING_REQUESTS,
          scope: this.payloadScope
        });
      }
    })
  }
})
export default class ProvisionRequestPayloadModal extends Mixins(
  RequestPromises
) {
  // Getters

  public payload!: any;
  public payloadScope!: string;

  // Props

  @Prop({ required: true })
  public requestId!: IProvisionRequest["id"];

  // Data

  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  // Life-cycle methods

  public created() {
    if (!this.isContentAvailable) return;

    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.PROVISIONING_REQUESTS,
      scope: this.payloadScope,
      vm: this
    });
  }

  // Methods

  public async loadData() {
    try {
      await this.getRequestPayload();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getRequestPayload() {
    return this.$store.dispatch(
      `data/${DataModules.PROVISIONING_REQUESTS}/getPayload`,
      {
        id: this.requestId,
        scope: this.payloadScope,
        vm: this,
        ignoreStored: this.isReloading
      }
    );
  }

  public copyToClipboard() {
    this.$copyToClipboard(JSON.stringify(this.payload));
  }

  // Guarding

  public guardFunctionalities = ["get_provision_request_payload"];

  public get isContentAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
